import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "image-preview" }
const _hoisted_3 = ["src"]

import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';

// import type { UploadProps, UploadUserFile } from 'element-plus'
import Bmob from 'hydrogen-js-sdk'

interface ImageInfo {
  createdAt: string; // 创建时间
  name: string; // 图片名称
  objectId: string; // 对象ID
  status: string; // 状态
  uid: number; // 用户ID
  updatedAt: string; // 更新时间
  url: string; // 图片URL
}

interface UploadProps {
  onRemove: (file: ImageInfo, files: ImageInfo[]) => void;
  onPreview: (file: ImageInfo, files: ImageInfo[]) => void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

console.log('upload');

let imgUrl = {}


let imgTag = ref(``);




let fileList = ref<ImageInfo[]>([])

const query = Bmob.Query('pic_list');
query.find().then(res => {
  // 确保 res 是 UploadUserFile[] 类型
  if (Array.isArray(res)) {
    fileList.value = res;
  } else {
    console.error('查询结果类型不匹配');
  }
});

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

// 定义函数参数类型
function copyText(label: string): Promise<void> {
  let content = '';
  switch (label) {
    case 'URL':
      content = imgUrl.value;
      break;
    case 'HTML':
      content = `<img src="${imgUrl.value}" alt="Image">`;
      break;
    case 'CSS':
      content = `background-image: url('${imgUrl.value}');`;
      break;
    case 'Markdown':
      content = `![Image](${imgUrl.value})`;
      break;
    case 'MD-Link':
      content = `[Link](${imgUrl.value})`;
      break;
    case 'BBCode':
      content = `[img]${imgUrl.value}[/img]`;
      break;
    case 'UBB':
      content = `[img]${imgUrl.value}[/img]`;
      break;
    case 'Custom':
      content = imgUrl.value;
      break;
    default:
      content = imgUrl.value;
  }

  return navigator.clipboard.writeText(content)
    .then(() => {
      ElMessage.success(`${label} content copied to clipboard.`);
    })
    .catch((err) => {
      console.error('Error copying content:', err);
      ElMessage.error('Failed to copy content to clipboard.');
    });
}



const handleRemove: UploadProps['onRemove'] = (uploadFile: ImageInfo, uploadFiles: ImageInfo[]) => {
  console.log(uploadFile);

  const query = Bmob.Query('pic_list');
  const objectId = uploadFile.objectId;

  query.destroy(objectId).then(res => {

    // 传入string是单个文件删除，传入array是批量删除
    const del = Bmob.File("a", "jfdf");
    const val = [uploadFile.url]
    del.destroy(val).then(res => {
      console.log(res);
    }).catch(err => {
      console.log(err)
    })
  }).catch(err => {
    console.error('删除文件失败:', err);
  });
};


const customUpload = async (options) => {
  const file = Bmob.File(options.file.name, options.file);
  const res = await file.save();
  console.log("File saved successfully:", res);
  // 把URL保存到Bmob pic_list表中
  const query = Bmob.Query('pic_list');
  const data = {
    name: options.file.name,
    url: res[0].url
  };
  query.save(data).then(res => {
    console.log(res)
  }).catch(err => {
    console.log(err)
  })
}


// const handleRemove: UploadProps['onRemove'] = (uploadFile:ImageInfo, uploadFiles) => {
//   console.log(uploadFile)


//   const query = Bmob.Query('tableName');
//   const objectId = uploadFile.objectid; // 示例：使用 get 方法获取属性

//   query.destroy(objectId).then(res => {
//     console.log(res)
//   }).catch(err => {
//     console.log(err)
//   })
// }

const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  imgUrl = dialogImageUrl
  imgTag = ref(`<img src="${uploadFile.url}" alt="Image">`);
  dialogVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_upload, {
      "file-list": _unref(fileList),
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : fileList = $event)),
      action: "",
      "http-request": customUpload,
      "list-type": "picture-card",
      "on-preview": handlePictureCardPreview,
      "on-remove": handleRemove
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Plus))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["file-list"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("h2", null, "复制你的图床链接格式", -1)),
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "URL",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyText('URL')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" URL: " + _toDisplayString(_unref(imgUrl)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "HTML",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (copyText('HTML')))
            }, {
              default: _withCtx(() => [
                _cache[10] || (_cache[10] = _createTextVNode(" HTML:")),
                _createElementVNode("div", {
                  textContent: _toDisplayString(_unref(imgTag))
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "CSS",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (copyText('CSS')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CSS: background-image: url('" + _toDisplayString(_unref(imgUrl)) + "'); ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "Markdown",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (copyText('Markdown')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Markdown: ![Image](" + _toDisplayString(_unref(imgUrl)) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "MD-Link",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (copyText('MD-Link')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" MD-Link: [Link](" + _toDisplayString(_unref(imgUrl)) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "BBCode",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (copyText('BBCode')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" BBCode: [img]" + _toDisplayString(_unref(imgUrl)) + "[/img] ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "UBB",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (copyText('UBB')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" UBB: [img]" + _toDisplayString(_unref(imgUrl)) + "[/img] ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "Custom",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (copyText('Custom')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Custom: " + _toDisplayString(_unref(imgUrl)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[12] || (_cache[12] = _createElementVNode("div", null, [
          _createElementVNode("h2", null, "点击链接自动复制")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: dialogImageUrl.value,
            alt: "Preview Image"
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})